"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationWorkflowContextProvider = exports.useRegistrationWorkflowContext = void 0;
var react_1 = require("react");
var context_1 = require("./context");
var provider_1 = require("./provider");
Object.defineProperty(exports, "RegistrationWorkflowContextProvider", { enumerable: true, get: function () { return provider_1.RegistrationWorkflowContextProvider; } });
/**
 * Hook to get the data of each registration workflow screen
 *
 * @category Hooks
 * @private
 * @internal
 */
var useRegistrationWorkflowContext = function () {
    var context = (0, react_1.useContext)(context_1.RegistrationWorkflowContext);
    if (context === null) {
        throw new Error('useRegistrationWorkflowContext must be used within an RegistrationWorkflowContextProvider');
    }
    return context;
};
exports.useRegistrationWorkflowContext = useRegistrationWorkflowContext;
__exportStar(require("./types"), exports);
